import common from './common';
import selections from './selections';

export default {
  common,
  selections,
};
